import type { GraphQLFormattedError } from "graphql"

/**
 * Der Server hat das Speichern abgelehnt, weil der Stand inzwischen geaendert wurde
 * (extensions.classification VERSION_CONFLICT). useForm faengt ihn ab und startet
 * Neuladen + Zusammenfuehren erneut — deshalb kein Toast (notifyError ignoriert ihn).
 */
export class VersionConflictError extends Error {
  constructor() {
    super("Der Datensatz wurde inzwischen geaendert.")
    this.name = "VersionConflictError"
  }
}

type WithErrors = { errors?: readonly GraphQLFormattedError[] | null } | null | undefined

/** Vor notifyErrors(result.errors) aufrufen: macht einen Versionskonflikt zur Exception. */
export function throwOnVersionConflict<R extends WithErrors>(result: R): R {
  if (result?.errors?.some((e) => e.extensions?.classification === "VERSION_CONFLICT")) {
    throw new VersionConflictError()
  }
  return result
}
